<template>
  <button :class="classes" aria-label="open menu">
    <span class="ui-hamburger__1"></span>
    <span class="ui-hamburger__2"></span>
    <span class="ui-hamburger__3"></span>
    <span class="ui-hamburger__4"></span>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

type Props = {
  open?: boolean
}

const props = defineProps<Props>()

const classes = computed(() => ({
  'ui-hamburger': true,
  'ui-hamburger--open': props.open,
}))
</script>

<style lang="scss">
@import '../styles/config';

.ui-hamburger {
  position: relative;
  width: 2.25rem;
  height: 2.25rem;
  overflow: hidden;

  span {
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    width: 100%;
    height: 0.125rem;
    margin-top: -1px;
    background-color: currentColor;
    transition:
      0.15s ease transform,
      0.15s ease opacity 0.15s,
      0.15s ease margin-top 0.15s,
      0.15s ease left 0.15s;

    &:nth-child(1) {
      margin-top: -0.75rem;
      left: 20%;
      transform: translate(0, -50%);
    }

    &:nth-child(2) {
      margin-top: -0.25rem;
      left: 10%;
      transform: translate(0, -50%);
    }

    &:nth-child(3) {
      margin-top: 0.25rem;
      transform: translate(0, -50%);
    }

    &:nth-child(4) {
      margin-top: 0.75rem;
      left: 20%;
      transform: translate(0, -50%);
    }
  }

  &--open {
    span {
      margin-top: 0 !important;
      left: 0 !important;
      transition:
        0.15s ease margin-top,
        0.15s ease left,
        0.15s ease opacity,
        0.15s ease transform 0.15s;

      &:nth-child(1) {
        transform: translate(0, 0) rotate(45deg);
      }

      &:nth-child(2) {
        transform: translate(0, 0);
        opacity: 0;
      }

      &:nth-child(3) {
        transform: translate(0, 0);
        opacity: 0;
      }

      &:nth-child(4) {
        transform: translate(0, 0) rotate(-45deg);
      }
    }
  }
}
</style>
